import { __decorate, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { Inline } from '../pvd-utils/enums/inline.js';

var VerticalAlign;
(function (VerticalAlign) {
    VerticalAlign["top"] = "top";
    VerticalAlign["center"] = "center";
    VerticalAlign["bottom"] = "bottom";
})(VerticalAlign || (VerticalAlign = {}));
const DEFAULT_DENSE = false;
const DEFAULT_FIXED_WIDTH = false;
const DEFAULT_INLINE = Inline.never;
const DEFAULT_VERTICAL_ALIGN = VerticalAlign.top;
/**
 * Providence Field Group component.
 * @see {@link https://providence.fmr.com/4.x/components/field-group/field-group.html|Field Group documentation}
 */
class PvdFieldGroup extends PvdSlotifyBaseComponent {
    constructor() {
        super(...arguments);
        this.pvdDense = DEFAULT_DENSE;
        this.pvdFixedWidth = DEFAULT_FIXED_WIDTH;
        this.pvdInline = DEFAULT_INLINE;
        this.pvdVerticalAlign = DEFAULT_VERTICAL_ALIGN;
        // #endregion
    }
    // #endregion
    // #region private methods
    get fieldGroupRole() {
        return this.pvdAriaLabel || this.pvdAriaLabelledby ? 'group' : undefined;
    }
    // #endregion
    // #region LitElement lifecycles
    renderGroupLabel() {
        return this.isSlotUsed('group-label')
            ? x `<div class="pvd-field-group__group-label"><s-slot name="group-label"></s-slot></div>`
            : x `<s-slot name="group-label"></s-slot>`;
    }
    render() {
        const classMap = {
            default: `${this.constructor.namespace}-field-group-root`,
            modifierPrefix: 'pvd-field-group',
            modifiers: [
                {
                    condition: this.pvdDense,
                    className: 'dense',
                },
                {
                    condition: true,
                    className: this.pvdFixedWidth ? 'fixed-width' : 'full-width',
                },
                {
                    condition: this.pvdInline !== Inline.never,
                    className: 'inline',
                },
                {
                    condition: this.pvdInline !== Inline.never,
                    className: `inline-${this.pvdInline}`,
                },
                {
                    condition: this.pvdVerticalAlign !== undefined,
                    className: `vertical-align-${this.pvdVerticalAlign}`,
                },
            ],
        };
        return x `<div class="${getClassName(classMap)}">${this.renderGroupLabel()}<div aria-describedby="${l(this.pvdAriaDescribedby)}" aria-label="${l(this.pvdAriaLabel)}" aria-labelledby="${l(this.pvdAriaLabelledby)}" class="pvd-field-group__field-group" role="${l(this.fieldGroupRole)}"><s-slot></s-slot></div></div>`;
    }
}
//#region Component configuration
PvdFieldGroup.componentName = 'field-group';
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-aria-describedby' }),
    __metadata("design:type", String)
], PvdFieldGroup.prototype, "pvdAriaDescribedby", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-aria-label' }),
    __metadata("design:type", String)
], PvdFieldGroup.prototype, "pvdAriaLabel", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-aria-labelledby' }),
    __metadata("design:type", String)
], PvdFieldGroup.prototype, "pvdAriaLabelledby", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-dense',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-dense'),
    }),
    __metadata("design:type", Boolean)
], PvdFieldGroup.prototype, "pvdDense", void 0);
__decorate([
    n({
        type: Boolean,
        reflect: true,
        attribute: 'pvd-fixed-width',
        ...PvdSlotifyBaseComponent.booleanAttribute('pvd-fixed-width'),
    }),
    __metadata("design:type", Boolean)
], PvdFieldGroup.prototype, "pvdFixedWidth", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-inline' }),
    __metadata("design:type", String)
], PvdFieldGroup.prototype, "pvdInline", void 0);
__decorate([
    n({ type: String, reflect: true, attribute: 'pvd-vertical-align' }),
    __metadata("design:type", String)
], PvdFieldGroup.prototype, "pvdVerticalAlign", void 0);

export { DEFAULT_DENSE, DEFAULT_FIXED_WIDTH, DEFAULT_INLINE, DEFAULT_VERTICAL_ALIGN, PvdFieldGroup, VerticalAlign };
//# sourceMappingURL=pvd-field-group.js.map
